/**
 * Scrolling Banner JavaScript File
 */

// Track processed banners to prevent duplication
const processedBanners = new Set();

/**
 * Initialize a scrolling banner with proper visibility and animation
 */
function initScrollingBanner(banner) {
  // Skip if already processed (prevents duplication)
  if (!banner || !banner.id || processedBanners.has(banner.id)) {
    return;
  }
  
  console.log('Initializing scrolling banner:', banner.id);
  processedBanners.add(banner.id);
  
  // Force visibility
  banner.style.display = 'block';
  banner.style.visibility = 'visible';
  banner.style.opacity = '1';
  
  // Ensure container is visible
  const container = banner.querySelector('.scrolling-banner__items-container');
  if (container) {
    container.style.display = 'flex';
    container.style.visibility = 'visible';
    container.style.opacity = '1';
  }
  
  // Ensure animation is running on all items
  const items = banner.querySelectorAll('.scrolling-banner__items');
  if (items.length > 0) {
    items.forEach(item => {
      item.style.display = 'flex';
      item.style.visibility = 'visible';
      item.style.opacity = '1';
      item.style.animationPlayState = 'running';
    });
  }
}

/**
 * Initialize all scrolling banners on the page
 */
function initAllScrollingBanners() {
  const banners = document.querySelectorAll('.scrolling-banner');
  if (banners.length > 0) {
    console.log(`Found ${banners.length} scrolling banners to initialize`);
    banners.forEach(initScrollingBanner);
  } else {
    console.log('No scrolling banners found on page');
  }
}

// Run on DOM content loaded
document.addEventListener('DOMContentLoaded', initAllScrollingBanners);

// Run when sections are loaded via Shopify section:load event
document.addEventListener('shopify:section:load', (event) => {
  const banner = event.target.querySelector('.scrolling-banner');
  if (banner) {
    console.log('New scrolling banner loaded via Shopify section:load');
    initScrollingBanner(banner);
  }
});

// Also run on window load to catch any missed banners
window.addEventListener('load', initAllScrollingBanners); 